import { ProfileSettingsService } from 'src/app/services/shared/profile-settings/profile-settings.service';
import { MatDialog } from '@angular/material/dialog';
import { NotificationService } from 'src/app/services/shared/notification/notification.service';
import { SessionService } from 'src/app/services/session/session.service';
import { copyTextToClipboard, jsonDeepParse } from 'src/app/functions/shared-functions';
import { Component, Input, OnInit, OnChanges } from '@angular/core';
import { environment } from 'src/environments/environment';
import { JobseekerRegistrationService } from '../../jobseeker-registration/services/registration/jobseeker-registration.service';
import { ChangePasswordComponent } from '../../login/components/change-password/change-password.component';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss'],
  providers: [JobseekerRegistrationService]
})
export class UserProfileComponent implements OnInit, OnChanges {
  @Input() data
  @Input() sideNavRef;
  resId: number;
  resume_details: any = {};
  profile_percentage: any = 0;
  wallet_data: any = {};
  user_basic_details: any = {}
  activeForChange = 1;
  constructor(
    private registration_srv: JobseekerRegistrationService,
    private session_srv: SessionService,
    private notification: NotificationService,
    private dialog: MatDialog,
    private profile_settings_srv: ProfileSettingsService
  ) { }

  ngOnInit(): void {
    this.session_srv.getSession().subscribe(res => {
      if (res && res['token']) {
        console.log(res)
        this.user_basic_details = res;
        let id = sessionStorage.getItem('resId')
        if (id && parseInt(id) > 0) {
          this.resId = parseInt(id);
          let code = localStorage.getItem('sellerShortCode');
          if (code && code != '') {
            // this.loadResumeWithMasters(parseInt(id));
          }
          else {
            this.profile_settings_srv.loadDefaultSettings().subscribe(res => {
              if (res && res['data']) {
                localStorage.setItem('sellerShortCode', res['data'].sellerShortCode);
                // this.loadResumeWithMasters(parseInt(id));
              }
            })
          }
          // this.loadWallletBalance();
        }
      }
    })


  }
  ngOnChanges(ev) {
    console.log(ev)
    if (ev && ev.data) {
      this.data = ev.data.currentValue;
      if (this.data && this.data.checkForResume) {
        let id = sessionStorage.getItem('resId')
        if (id && parseInt(id) > 0) {
          this.resId = parseInt(id);
          // this.loadResumeWithMasters(parseInt(id));
          // this.loadWallletBalance();
        }
      }
    }
  }

  loadWallletBalance() {
    this.registration_srv.getTalBalance({
      isCVMine: 1
    }).subscribe(res => {
      if (res && res['data']) {
        this.wallet_data = res['data'];
        this.user_basic_details = res['data'];
      }
    })
  }
  loadResumeWithMasters(resId) {
    this.registration_srv.getResumeDetailsWithMaster({
      resId: resId,
      sellerShortCode: environment.SHORTCODE
    }).subscribe(res => {
      if (res && res['data']) {
        if (res['data'].resumeDetails) {
          this.resume_details = jsonDeepParse(res['data'].resumeDetails);
          this.calculatePercentage(this.resume_details)
        }
      }
    })
  }
  changePassword() {
    this.dialog.open(ChangePasswordComponent, {
      width: '40%',
      panelClass: "JS-dialog"
    })
  }
  calculatePercentage(data) {
    if (data) {
      let keys = Object.keys(data)
      let percentage = 0;
      if (keys.length) {
        keys.forEach(k => {
          if (k == "education" && data[k] && data[k].length) {
            percentage += 10;
          }
          else if (k == "firstName" && data[k] && data[k] != '') {
            percentage += 10;
          }
          else if (k == "mobileNumber" && data[k] && data[k] != '') {
            percentage += 10;
          }
          else if (k == "emailId" && data[k] && data[k] != '') {
            percentage += 10;
          }
          else if (k == "keySkills" && data[k] && data[k].length) {
            percentage += 10;
          }
          else if (k == "jobType" && data[k] && data[k].length) {
            percentage += 10;
          }
          else if (k == "cvPath" && data[k] && data[k] != '') {
            percentage += 10;
          }
          else if (k == "noticePeriod" && (data[k] || data[k] == 0) && data[k] != '') {
            percentage += 5;
          }
          else if (k == "totalExp" && (data[k] || data[k] == 0) && data[k] != '') {
            percentage += 5;
          }
          else if (k == "presentLocation" && data[k] && data[k] != '') {
            percentage += 5;
          }

        })
        this.profile_percentage = percentage
      }
    }
  }
  openRoute(checkOpen, url) {
    this.sideNavRef(1, url)
  }
  logout() {
    this.sideNavRef(null, null)
    this.session_srv.logout();
  }

  copyToClipboard() {
    if (this.user_basic_details) {
      copyTextToClipboard(this.user_basic_details.whatsappShareContent)
      this.notification.success('Copied to clipboard', 'CLose', 5000)
    }
  }
  openMail() {
    let mail = "mailto:?subject=" + this.user_basic_details.emailShareContentSubject + "&body=" + this.user_basic_details.emailShareContentMailBody;
    window.open(mail, '_blank')
  }
  openExternalLink(link) {
    window.open(link, '_blank')
  }
}
